import Apple from '../../svg/PaymentLogos/apple.svg';
import Google from '../../svg/PaymentLogos/google.svg';
import Mastercard from '../../svg/PaymentLogos/mastercard.svg';
import Paypal from '../../svg/PaymentLogos/paypal.svg';
import Visa from '../../svg/PaymentLogos/visa.svg';

export const PaymentLogoSection = () => {
  return (
    <div className="flex flex-col gap-2">
      <p className="font-black text-[15px] text-center md:text-left text-[#4A4A4A] mb-0">
        Payments We Accept
      </p>
      <div className="flex gap-2" style={{ color: '#4A4A4A' }}>
        <span style={{ width: '50px' }}>
          <Paypal />
        </span>
        <span style={{ width: '50px' }}>
          <Google />
        </span>
        <span style={{ width: '50px' }}>
          <Apple />
        </span>
        <span style={{ width: '50px' }}>
          <Visa />
        </span>
        <span style={{ width: '50px' }}>
          <Mastercard />
        </span>
      </div>
    </div>
  );
};
